import { render, staticRenderFns } from "./Caixa.vue?vue&type=template&id=0d575689&scoped=true&"
import script from "./Caixa.vue?vue&type=script&lang=js&"
export * from "./Caixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d575689",
  null
  
)

export default component.exports